module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyBill",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyBill"
    }
  }, [_vm._v("学期缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistory"
    }
  }, [_vm._v("学期缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillExam"
    }
  }, [_vm._v("其他缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistoryExam"
    }
  }, [_vm._v("其他缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Card"
    }
  }, [_vm._v("银行卡")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeTypeVisible),
      expression: "feeTypeVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("按学年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("按学期")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextFee()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.semesterPayVisible),
      expression: "semesterPayVisible"
    }],
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "12px",
      "border-radius": "8px"
    },
    attrs: {
      "src": "",
      "width": "90",
      "height": "120"
    }
  })]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billVisible),
      expression: "billVisible"
    }]
  }, [_c('el-form', {
    ref: "viewForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.viewForm,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "班级"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.className))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.academicYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "应缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.payableAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "减免总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.reduceAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "实缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.feeAmount, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细",
      "name": "1"
    }
  }, [_c('el-row', [_vm._l((_vm.feeData), function(item) {
    return _c('div', {
      key: item.feeNo
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.feeName))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  }), _vm._v(" "), _vm._l((_vm.reduceList), function(item) {
    return _c('div', {
      key: item.feeNo
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.feeNo))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examBillVisible),
      expression: "examBillVisible"
    }]
  }, [_c('el-form', {
    ref: "viewForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.viewForm,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "班级"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.className))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.academicYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学期"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.termNM))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.totals, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "feeResultTable",
    attrs: {
      "data": _vm.feeData
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "row-click": _vm.isShow
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用项",
      "prop": "feeNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "prop": "feeAmount",
      "formatter": _vm.dataFormat,
      "align": "right"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.termVisible),
      expression: "termVisible"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.termMsg))])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [(_vm.backVisible) ? _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.feePayType_UN) ? _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.payButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.toPay()
      }
    }
  }, [_vm._v("银联支付")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListHistoryVisible),
      expression: "feeListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('01')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '01')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '01')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      }), 1) : _vm._e()
    }), 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examListHistoryVisible),
      expression: "examListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('02')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatExamHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '02')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatExamHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '02')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatExamHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      }), 1) : _vm._e()
    }), 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "微信二维码",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixin
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7a0c53e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XiFan/MyBillXiFan_bak.vue
// module id = 1282
// module chunks = 1